






import { Component, Vue } from 'vue-property-decorator'
import ForgetPasswordForm from '@/components/ForgetPassword.vue'

@Component({
  components: {
    ForgetPasswordForm
  }
})
export default class Verify extends Vue {

}

